import React from "react";
import { Link } from "react-router-dom";
import { BUSINESS, UI, trackEvent } from "@/content/site";

export default function CtaBand({ section, lang }) {
  const ui = UI[lang];
  return (
    <section className="gw-cta-band">
      <div className="gw-container" style={{textAlign: "center"}}>
        <h2>{section.heading}</h2>
        {section.paragraph && <p>{section.paragraph}</p>}
        <div className="gw-cta-band-buttons">
          <Link
            to={ui.contactUrl}
            className="gw-btn gw-btn-primary gw-btn-lg"
            onClick={() => trackEvent("cta_click", { location: "cta_band", label: "consultation" })}
          >
            {ui.ctaConsultation}
          </Link>
          <a
            href={`tel:${BUSINESS.phoneTel}`}
            className="gw-btn gw-btn-accent gw-btn-lg"
            onClick={() => trackEvent("phone_click", { location: "cta_band" })}
          >
            {ui.ctaCall}
          </a>
        </div>
      </div>
      <style>{`
        .gw-cta-band { padding: var(--gw-space-16) 0; background: linear-gradient(135deg, #FFF4CF 0%, #F1C232 100%); }
        .gw-cta-band h2 { color: var(--gw-primary-dark); margin-bottom: var(--gw-space-3); }
        .gw-cta-band p { color: var(--gw-primary-dark); font-size: 1.1rem; max-width: 640px; margin: 0 auto var(--gw-space-6); }
        .gw-cta-band-buttons { display: flex; gap: var(--gw-space-3); justify-content: center; flex-wrap: wrap; }
      `}</style>
    </section>
  );
}
